// Free Shipping Progress Bar - Motion Theme Optimized
(function() {
  'use strict';
  
  let isUpdating = false;
  
  function updateFreeShippingBar(cart) {
    if (isUpdating) return;
    isUpdating = true;
    
    const progressEls = document.querySelectorAll('.free-shipping-progress');
    if (!progressEls.length) {
      isUpdating = false;
      return;
    }
    
    progressEls.forEach(progressEl => {
      const threshold = parseInt(progressEl.dataset.threshold) || 39900;
      const color = progressEl.dataset.color || '#CFA161';
      const cartTotal = cart ? cart.total_price : 0;
      const remaining = threshold - cartTotal;
      const progress = Math.min((cartTotal / threshold) * 100, 100);
      
      const textEl = progressEl.querySelector('.free-shipping__text');
      const fillEl = progressEl.querySelector('.free-shipping__bar-fill');
      
      if (!textEl || !fillEl) {
        isUpdating = false;
        return;
      }
      
      // Mark as initialized
      progressEl.setAttribute('data-initialized', 'true');
      
      if (cartTotal === 0) {
        // Empty cart
        textEl.innerHTML = `
          <span>Tilføj varer for </span>
          <span class="free-shipping__amount" style="color: ${color}">
            ${formatMoney(threshold)}
          </span>
          <span> for at få gratis fragt </span>
        `;
        textEl.classList.remove('free-shipping__text--success');
        fillEl.style.width = '0%';
      } else if (remaining > 0) {
        // Still need more for free shipping
        textEl.innerHTML = `
          <span>Du er kun </span>
          <span class="free-shipping__amount" style="color: ${color}">
            ${formatMoney(remaining)}
          </span>
          <span> væk fra gratis fragt </span>
        `;
        textEl.classList.remove('free-shipping__text--success');
        fillEl.style.width = progress + '%';
      } else {
        // Free shipping achieved
        textEl.innerHTML = `
          <svg class="icon icon-check" viewBox="0 0 20 20">
            <path d="M7.5 13.5L3.5 9.5L2 11L7.5 16.5L18 6L16.5 4.5L7.5 13.5Z"/>
          </svg>
          <span>Du har opnået GRATIS FRAGT! </span>
        `;
        textEl.classList.add('free-shipping__text--success');
        fillEl.style.width = '100%';
      }
    });
    
    setTimeout(() => { isUpdating = false; }, 100);
  }
  
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
  }
  
  function fetchCartAndUpdate() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(cart => {
      updateFreeShippingBar(cart);
    })
    .catch(err => {
      console.error('Cart fetch error:', err);
      isUpdating = false;
    });
  }
  
  // Initialize on specific Motion theme events
  function initializeEvents() {
    // Remove all existing listeners to avoid duplicates
    const events = [
      'theme:cart:change',
      'cart:refresh', 
      'cart:build',
      'ajaxCart:updated',
      'cart:updated',
      'product:added',
      'ajaxProduct:added'
    ];
    
    events.forEach(eventName => {
      document.addEventListener(eventName, function() {
        setTimeout(fetchCartAndUpdate, 200);
      });
    });
    
    // Watch for drawer open
    document.addEventListener('theme:drawer:opened', function(e) {
      if (e.detail && e.detail.drawer === 'CartDrawer') {
        setTimeout(fetchCartAndUpdate, 150);
      }
    });
    
    // Intercept cart modifications via fetch
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      return originalFetch.apply(this, args).then(response => {
        const url = args[0];
        if (typeof url === 'string' && 
            (url.includes('/cart/add') || 
             url.includes('/cart/update') || 
             url.includes('/cart/change'))) {
          setTimeout(fetchCartAndUpdate, 300);
        }
        return response;
      });
    };
  }
  
  // Watch for dynamic cart drawer content
  function observeCartDrawer() {
    const drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;
    
    const observer = new MutationObserver(function(mutations) {
      const hasRelevantChange = mutations.some(mutation => {
        return mutation.type === 'attributes' && 
               mutation.attributeName === 'class' &&
               mutation.target.classList.contains('is-open');
      });
      
      if (hasRelevantChange) {
        setTimeout(fetchCartAndUpdate, 200);
      }
    });
    
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    initializeEvents();
    observeCartDrawer();
    
    // Initial update with delay to ensure cart is loaded
    setTimeout(fetchCartAndUpdate, 100);
    
    // Backup update in case first one fails
    setTimeout(fetchCartAndUpdate, 500);
  }
  
  // Global function for manual updates
  window.updateFreeShippingBar = fetchCartAndUpdate;
  
})();